import { useState } from 'react';

const testimonials = [
  {
    title: '新規クライアント獲得に悩むコンサルティング会社のオーナー様',
    content:
      '「X（旧twitter）から取引先ができると思っていませんでした。atcoさんに勧めていただいた"カジュアルなつながりから長期的な関係を築き、相手が必要とするタイミングでビジネスをつくる"というのはなかなか時間がかかる取り組みではありましたが、継続することで徐々につながっている方が増え、案件が増やすことができました。」',
  },
  {
    title: 'システムエンジニアのリソース不足に悩んでいた小売事業会社のシステム責任者様',
    content:
      '「エージェントさんに声をかければ候補者は大量にでてきますが、書面の要件では確かに要件を満たす方を紹介いただけるものの、仕事に取り組む姿勢や業務の理解力までは紹介時にフィルタリングしてくれません。atcoさんはそのあたりもみてくれているので採用効率が高く助かっています。」',
  },
  {
    title: '事業譲渡希望者を探していたM&A仲介会社の営業担当者様',
    content:
      '「うちの特徴は大手M&A仲介では単価が安くて対応しないスモールM&Aに柔軟に対応していることなのですが、これをどうやって売り主様に認知してもらうか方法がわかりませんでした。そんな中atcoさんは我々と一緒に悩んでくれて、ベストな集客方法を提案くださり、今では安定的に売り主様とである仕組みが構築できています。」',
  },
];

const TestimonialsSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="testimonials" className="py-20 bg-[#2f4a38]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[#a8c9b5] text-xs font-semibold tracking-widest uppercase mb-3">Testimonials</p>
          <h2 className="text-2xl md:text-3xl font-bold text-white">お客様の声</h2>
        </div>
        <div className="flex flex-col gap-4">
          {testimonials.map((item, index) => (
            <div key={index} className="bg-white/10 rounded-lg overflow-hidden">
              <button
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
                onClick={() => toggle(index)}
              >
                <span className="text-sm font-semibold text-white pr-4">{item.title}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-white/70 text-base`}></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-white/80 text-sm leading-relaxed">{item.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
